import { render, staticRenderFns } from "./CtaChupetes.vue?vue&type=template&id=5d28c96f"
import script from "./CtaChupetes.vue?vue&type=script&lang=js"
export * from "./CtaChupetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports